import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
/** THD Badge component. */


export function badgeToClass({ type, className }) {
  const prefix = 'value-price-badge__';
  const classes = {
    'bulk-price': `${prefix}Bulk-Price`,
    'bulk-price-small': `${prefix}Bulk-Price small-badge`,
    'lower-price': `${prefix}New-Lower-Price`,
    'lower-price-small': `${prefix}New-Lower-Price small-badge`,
    'value-price': `${prefix}Special-Buy`,
    'value-price-small': `${prefix}Special-Buy small-badge`,
    overstock: `${prefix}Over-Stock`,
    'overstock-small': `${prefix}Over-Stock small-badge`,
    text: 'badge-container u__bold'
  };
  return classNames(
    classes[type],
    className
  );
}

const Badge = (props) => {
  const {
    children, className, color, text, type
  } = props;
  return (
    <span
      className={badgeToClass({ type, className })}
      title={text}
      style={{ backgroundColor: color }}
    >
      {text || children}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]),
  className: PropTypes.string,
  /** CSS Valid color value, used to set the background color of the text badge. */
  color: PropTypes.string,
  /** Text badge text. */
  text: PropTypes.string,
  /** Badge to display. Options:
   * 'bulk-price',
   'bulk-price-small',
   'lower-price',
   'lower-price-small',
   'value-price',
   'value-price-small',
   'overstock',
   'overstock-small',
   'text' */
  type: PropTypes.oneOf([
    'bulk-price',
    'bulk-price-small',
    'lower-price',
    'lower-price-small',
    'value-price',
    'value-price-small',
    'overstock',
    'overstock-small',
    'text'
  ])
};

Badge.defaultProps = {
  children: null,
  className: null,
  color: null,
  text: null,
  type: 'text'
};

export default Badge;
